import React, { ReactElement, ButtonHTMLAttributes } from "react";
import "./custom-button.scss";
import Loader from "@/components/common/loader/loader";
import { isNil } from "lodash";

interface CustomButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
    isLoading?: boolean;
    id: string;
    dataCy: string;
    dataTestId?: string;
    isDisabled?: boolean;
    text: string | ReactElement;
    handleClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
    rightIcon?: ReactElement;
    leftIcon?: ReactElement;
}

const CustomButton: React.FC<CustomButtonProps> = ({
    className,
    isLoading,
    id,
    dataCy,
    dataTestId,
    isDisabled,
    text,
    handleClick,
    rightIcon,
    leftIcon,
    type = "button",
    ...restProps
}) => {
    return (
        <>
            <button
                className={className ?? ""}
                {...(handleClick && { onClick: handleClick })}
                id={id}
                data-cy={dataCy}
                {...(dataTestId && { "data-testid": dataTestId })}
                disabled={isLoading ? true : isDisabled}
                type={type}
                {...restProps}
            >
                {!isNil(leftIcon) ? leftIcon : null}
                {isLoading ? <Loader isInline size={15} loading={isLoading} /> : text}
                {!isNil(rightIcon) ? rightIcon : null}
            </button>
        </>
    );
};

export default CustomButton;
